<template>
  <span
    class="cu-badge"
    :class="classes"
  >
    {{ text }}
  </span>
</template>

<script>
  export default {
    name: 'IntegrationGameActiveBadge',
    props: {
      integrationGame: {
        type: Object,
        required: true
      }
    },
    computed: {
      text () {
        return this.integrationGame.active ? this.$t('integrations.gameActive') : this.$t('integrations.gameInactive')
      },
      classes () {
        return [
          this.integrationGame.active ? 'cu-badge--active' : 'cu-badge--inactive'
        ]
      }
    },
  }
</script>

<style
  lang="scss"
  scoped
>

</style>
